export { default } from "./SocialNetworks";